<div mat-dialog-title role="heading" aria-level="1">
	Editing Program FTE
</div>

<mat-dialog-content style="padding:0 !important;">
	<div class="my-3 text-sm">
		<div class="row" style="margin:0 !important;">
			<div class="col-6">
				<span class="h5">Instructions</span>
				<p>
					First, select the programmatic topics in the dropdown menu that your work focuses on. 
					Then, for each item, enter a percent of time that you spend focusing on that topic; no less than 10 percent. 
					Your FTE should reflect all of your work on this topic, not just time you spend collaborating with the related UC ANR Program Teams.
				</p>
			</div>
			<div class="col-6">
				<span class="h5">How this information will be used</span>
				<p>
					The FTE you provide will determine how you are displayed on 
          <a href='https://ucanr.edu/site/ucanr-programmatic-footprint-maps' target='_blank'><i class="fa fa-external-link-alt"></i> UC ANR’s Programmatic Footprint Maps</a>
				</p>
			</div>
		</div>

	</div>

	<div>
		<div [formGroup]="form">
			<table class="table table-bordered table-flush-except-top">
				<thead>
					<tr>
						<th class="text-center">Remove</th>
						<th>
							<span [matTooltip]="StaticText.ProgramAreaToolTip">
								Program
								<i class="fa fa-fw fa-info-circle text-muted"></i>
							</span>
						</th>
						<th style="width:8em;">
							<span [matTooltip]="tooltipSvc.tooltip('Program.YearlyFTE')">
								Yearly FTE
								<i class="fa fa-fw fa-info-circle text-muted"></i>
							</span>
						</th>
					</tr>
				</thead>
				<tbody formArrayName="programAreas">
					<ng-container *ngFor="let pa of form.get('programAreas')?.controls; index as pa_index" [formGroupName]="pa_index">
						<tr>
							<td>
								<button class="btn btn-link text-danger btn-sm"
								(click)="form.controls.programAreas.removeAt(pa_index)"
								matTooltip="Remove this program area">
									Remove
								</button>
							</td>
							<td>
								<select formControlName="programAreaId" class="form-control form-control-sm"
									[title]="programAreaNameById[form.value.programAreas[pa_index].programAreaId] || ''">
									<option [value]="null" disabled>
										- Select a Program Area -
									</option>
									<option *ngFor="let pa of availableProgramAreas(pa_index)" [value]="pa.id" [disabled]="pa.disabled" [class]="programAreaClass(pa.disabled)">
										{{pa.name}} <span *ngIf="pa.disabled">(No longer active)</span>
									</option>
								</select>
							</td>
							<td>
								<div class="input-group input-group-sm">
									<input type="number" formControlName="fte"
										min="10" step="1" max="100" class="form-control"
										placeholder="FTE" aria-label="Yearly FTE">
									<span class="input-group-addon">%</span>
								</div>
							</td>
						</tr>
					</ng-container>
					<tr>
						<td>&nbsp;</td>
						<td colspan="4">
							<button class="btn btn-sm btn-link" (click)="addProgramAreaRow()">
								+ Add a Program
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions>
	<div class="row">
		<div class="col-md-4 text-left"></div>
		<div class="col-md-4">
			<form class="form-inline">
				<div class="input-group">
					<label class="mr-2">
						Total FTE:
					</label>
					<div class="input-group input-group-white">
						<input type="text" [value]="(sum | number : '1.0-0') + '%'"
						class="form-control" disabled aria-label="Total FTE">

						<div class="input-group-addon" [ngSwitch]="validSum">
							<span *ngSwitchCase="true" matTooltip="Great job!">
								<i class="fa fa-fw fa-check text-success"></i>
							</span>
							<span *ngSwitchCase="false" matTooltip="Total FTE must equal 100%">
								<i class="fa fa-fw fa-warning text-warning"></i>
							</span>
						</div>
					</div>
				</div>
			</form>
		</div>

		<div class="col-md-4">
			<button (click)="cancel()" class="btn btn-link" [disabled]="closing">
				Cancel
			</button>
			<button (click)="save()" class="btn btn-primary" [disabled]="closing || !validSum">
				Save
			</button>
		</div>
	</div>
</mat-dialog-actions>
